/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Footer_FeaturesInputs */



/**
* | output |
* | --- |
* | "Features" |
*
* @param {Footer_FeaturesInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
export const footer_features = /** @type {((inputs?: Footer_FeaturesInputs, options?: { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Footer_FeaturesInputs, { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Funktionen")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Fonctionnalités")
	if (locale === "zh-Hans") return /** @type {LocalizedString} */ ("功能")
	if (locale === "zh-Hant") return /** @type {LocalizedString} */ ("功能")
	if (locale === "ko") return /** @type {LocalizedString} */ ("기능")
	return /** @type {LocalizedString} */ ("Features")
});